import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { HowItWorksSection } from '../components/sales/HowItWorksSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-205" data-mp="3vmi5nliu4poy">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-206" data-mp="3akrv1q7tia2s">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-207" data-mp="35shyhrc76brj">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-208" data-mp="30tneim2huh5u">
            PMU Instructor Ready™ · by Prof. Kyra
          </p>
        </div>
      </header>

      <main data-id="element-209" data-mp="3tj465hiahu10">
        <HeroSection data-id="element-210" data-mp="3tiufrstc1kus" />
        <InsideSection data-id="element-211" data-mp="3ti2i8cg6dd1v" />
        <PainSection data-id="element-212" data-mp="3tghxfejnx8h7" />
        <SolutionSection data-id="element-213" data-mp="3ojr8e1pvr2jn" />
        <VolumesSection data-id="element-214" data-mp="3oj7yn8advkgp" />
        <BonusesSection data-id="element-215" data-mp="3ok0yrqeu7bpv" />
        <BeforeAfterSection data-id="element-216" data-mp="3oholhqk0xpj5" />
        <AudienceSection data-id="element-217" data-mp="3jjvewwet6tic" />
        <OfferSection data-id="element-218" data-mp="3jj3jpmp4ixsl" />
        <HowItWorksSection data-id="element-219" data-mp="3jilgg641njb6" />
        <FaqSection data-id="element-220" data-mp="3fitdqa1c07dq" />
        <FinalSection data-id="element-221" data-mp="3fjcon6skdvi9" />
      </main>

      <SiteFooter data-id="element-222" data-mp="3fi9tgmo7l6wj" />
    </div>;
}